import * as React from 'react';
import { IconButton } from '@material-ui/core';
import { FirstPage as FirstPageIcon } from '@material-ui/icons';
import { KeyboardArrowLeft as KeyboardArrowLeftIcon } from '@material-ui/icons';
import { KeyboardArrowRight as KeyboardArrowRightIcon } from '@material-ui/icons';
import { LastPage as LastPageIcon } from '@material-ui/icons';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { translation } from '../i18n';


interface Props {
  onChangePage: (event: any, pageNumber: number) => void,
  page: number,
  totalPages: number,
}

type LocalStyles = 'root' | 'buttons';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'right',
  },
  buttons: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
    marginRight: theme.spacing.unit * 2.5,
  },

});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

class PaginationNavigation extends React.Component<PropsWithStyle, {}> {

  public render() {
    const {classes, page, totalPages} = this.props;

    return (
      <>
        {this.props.totalPages <= 1 ? <></> :
          <div className={classes.root}>
            <Typography variant="body1" color={'textSecondary'}>
              {translation.t('paginationNavigation.page', { actual: (page + 1), complete: totalPages })}
            </Typography>
            <div className={classes.buttons}>
              <IconButton
                onClick={this.handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label={translation.t('paginationNavigation.first')}
              >
                <FirstPageIcon/>
              </IconButton>
              <IconButton
                onClick={this.handleBackButtonClick}
                disabled={page === 0}
                aria-label={translation.t('paginationNavigation.previous')}
              >
                <KeyboardArrowLeftIcon/>
              </IconButton>
              <IconButton
                onClick={this.handleNextButtonClick}
                disabled={page >= totalPages - 1}
                aria-label={translation.t('paginationNavigation.next')}
              >
                <KeyboardArrowRightIcon/>
              </IconButton>
              <IconButton
                onClick={this.handleLastPageButtonClick}
                disabled={page >= totalPages - 1}
                aria-label={translation.t('paginationNavigation.last')}
              >
                <LastPageIcon/>
              </IconButton>
            </div>
          </div>
        }
      </>
    );
  }

  private handleFirstPageButtonClick = (event: any) => {
    this.props.onChangePage(event, 0);
  };

  private handleBackButtonClick = (event: any) => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  private handleNextButtonClick = (event: any) => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  private handleLastPageButtonClick = (event: any) => {
    this.props.onChangePage(
      event,
      Math.max(0, this.props.totalPages - 1),
    );
  };
}

export default withStyles(localStyles, {withTheme: true})(PaginationNavigation);
